<template>
  <div ref="wrapper" class="relative event-aware">
    <slot />
  </div>
</template>

<script>
import { EVENT_OBSERVERS } from '@state/modules/event-observer'
import { mapGetters } from 'vuex'

export default {
  props: {
    ignore: {
      type: Boolean,
      required: false,
    },
    answer: {
      type: Boolean,
      required: false,
    },
    stopPropagation: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      events: [],
      elements: [],
    }
  },
  computed: {
    ...mapGetters(EVENT_OBSERVERS.NAME, [EVENT_OBSERVERS.GET_SETTING]),
    wrapperElement() {
      return this.$refs.wrapper
    },
  },
  watch: {
    GET_SETTING: {
      handler() {
        this.updateBindings()
      },
      deep: true,
    },
  },
  mounted() {
    this.updateBindings()

    this.$store.subscribeAction((action, state) => {
      if (action.type === EVENT_OBSERVERS.NAMESPACE(EVENT_OBSERVERS.SET_SETTING)) {
        this.updateBindings()
      }
    })
  },
  beforeDestroy() {
    this.unBindProxy()
  },
  methods: {
    updateBindings() {
      this.events = this.GET_SETTING.events
      this.elements = this.GET_SETTING.elements
      this.unBindProxy()
      this.bindProxy()
    },
    bindProxy() {
      if (this.wrapperElement && this.events && this.events.length) {
        for (const event of this.events) {
          this.wrapperElement.addEventListener(event, this.aware)
        }
      }
    },
    unBindProxy() {
      if (this.wrapperElement && this.events && this.events.length) {
        for (const event of this.events) {
          this.wrapperElement.removeEventListener(event, this.aware)
        }
      }
    },
    aware(event) {
      // stop event bubbling
      if (this.stopPropagation) {
        if (event && event.stopPropagation) {
          event.stopPropagation()
        }
      }

      // set the event option
      event.ignore = this.ignore
      event.answer = this.answer
      this.$emit('aware', event)
    },
  },
}
</script>
